<template>
  <footer class="row center">
    <div class="footer__container column">
      <div class="footer__links row">
        <Logo mode="light" class="link__container row center logo" />
        <Contact class="link__container row center" />
        <Auth class="link__container row center" />
        <Company class="link__container row center" />
      </div>

      <div class="footer__disclaimer">© 2025 arcticreply - all rights reserved.</div>
    </div>
  </footer>
</template>

<script>
import Logo from '../header/components/Logo.vue'
import Contact from './components/Contact.vue'
import Auth from './components/Auth.vue'
import Company from './components/Company.vue'

export default {
  name: 'Footer',
  components: { Logo, Contact, Auth, Company },
  setup() {},
}
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  background-color: var(--dark-10);
  color: white;
  margin-top: 150px;

  .footer__container {
    width: calc(100% - 40px);
    padding: 40px 20px;
    align-items: center;
    justify-content: space-between;
    max-width: 2000px;

    .footer__links {
      margin-bottom: 40px;
      width: 100%;
      align-items: flex-start;

      @media (orientation: portrait) {
        flex-wrap: wrap;
      }

      .link__container {
        width: 25%;

        &.logo {
          margin: auto 0;
        }

        @media (orientation: portrait) {
          width: 50%;
        }
      }
    }

    .footer__disclaimer {
      font-size: 0.8rem;
      font-style: italic;

      a {
        color: var(--arctic);

        &:hover {
          text-decoration: underline;
        }
      }

      @media (orientation: portrait) {
        text-align: center;
      }
    }
  }
}
</style>
